import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ImpersonationBanner from './ImpersonationBanner';
import './HomePage.css';

const calculateTimeRemaining = (endTime) => {
  const now = new Date().getTime();
  const diff = endTime - now;

  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const speakers = [
  {
    name: " Hiroshi Nogami",
    affiliation: "Tohoku University, Japan",
    url: "https://www.r-info.tohoku.ac.jp/en/3ace24fb652e45919a59410fd85caede.html",
    imagePath: "/stis2025/assets/speakers_upscaled/Hiroshi Nogami.jpeg"
  },
  {
    name: " Nirupam Chakraborti",
    affiliation: "Czech Technical University, Prague",
    url: "https://scholar.google.co.kr/citations?user=RONBrJ0AAAAJ&hl=en",
    imagePath: "/stis2025/assets/speakers_upscaled/Nirupam_Chakraborti.jpeg"
  },
  {
    name: " M Akbar RHAMDHANI",
    affiliation: "Swinburne University of Technology",
    url: "https://scholar.google.com.au/citations?user=p6P73h0AAAAJ&hl=en",
    imagePath: "/stis2025/assets/speakers_upscaled/akbar.jpg"
  },
  {
    name: " Henrik Saxén",
    affiliation: "Abo Akademi University, Finland",
    url: "https://users.abo.fi/hsaxen/",
    imagePath: "/stis2025/assets/speakers_upscaled/Henrik Saxen.jpeg"
  },
  {
    name: " Jianliang Zhang",
    affiliation: "University of Science and Technology Beijing",
    url: "https://www.researchgate.net/profile/Jianliang-Zhang",
    imagePath: "/stis2025/assets/speakers_upscaled/Jianliang Zhang.jpg"
  },
  {
    name: " Shigeru Ueda",
    affiliation: "Tohoku University, Japan",
    url: "https://www.r-info.tohoku.ac.jp/en/56a8d0a4aa0365e3d0e525661c8675b7.html",
    imagePath: "/stis2025/assets/speakers_upscaled/shigeru ueda.jpeg"
  },
  {
    name: " Ronald O'Malley",
    affiliation: "Missouri University of Science and Technology, USA",
    url: "https://scholar.google.com/citations?user=S_R3hM0AAAAJ&hl=en",
    imagePath: "/stis2025/assets/speakers_upscaled/Ronald J. O'Malley.jpeg"
  },
  {
    name: " Y Gordon",
    affiliation: "Hatch, Canada",
    url: "https://www.linkedin.com/in/iakov-gordon-a1976a15/?originalSubdomain=ca",
    imagePath: "/stis2025/assets/speakers_upscaled/Dr. Y Gordon.jpeg"
  },
  {
    name: "  Joohyun Park",
    affiliation: "Hanyang University, Korea",
    url: "http://hitep2.hanyang.ac.kr/member01.html",
    imagePath: "/stis2025/assets/speakers_upscaled/JOO HYUN PARK.jpeg"
  },
  {
    name: " H. Matsuura",
    affiliation: "University of Tokyo, Japan",
    url: "https://www.material.t.u-tokyo.ac.jp/faculty/hiroyuki_matsuura_e.html",
    imagePath: "/stis2025/assets/speakers_upscaled/Hiroyuki Matsuura.jpeg"
  },
  {
    name: " Alberto Conejo",
    affiliation: "USTB, China",
    url: "https://www.researchgate.net/profile/Alberto-Conejo",
    imagePath: "/stis2025/assets/speakers_upscaled/Alberto Conjego.jpeg"
  },
  {
    name: " Geoff Wang",
    affiliation: "University of Queensland, Australia",
    url: "https://about.uq.edu.au/experts/525",
    imagePath: "/stis2025/assets/speakers_upscaled/Geoff Wang.png"
  },
  {
    name: " Jung-Wook Cho",
    affiliation: "POSTECH, Korea",
    url: "https://www.researchgate.net/profile/Jungwook-Cho",
    imagePath: "/stis2025/assets/speakers_upscaled/Jungwook Cho.jpeg"
  },
  {
    name: " Konstantin V. Grigorovich",
    affiliation: "RAS, Russia",
    url: "https://www.researchgate.net/profile/Konstantin-Grigorovich",
    imagePath: "/stis2025/assets/speakers_upscaled/Konstantin Grigorovich.jpeg"
  },
  {
    name: " Miroslaw Karbowniczek",
    affiliation: "AGH University, Poland",
    url: "https://skos.agh.edu.pl/osoba/miroslaw-karbowniczek-1329.html",
    imagePath: "/stis2025/assets/speakers_upscaled/Mirosław Karbowniczek.jpeg"
  },
  {
    name: " Paulo Santos Assis",
    affiliation: "UFOP, Brazil",
    url: "https://www.researchgate.net/profile/Paulo-Assis-2",
    imagePath: "/stis2025/assets/speakers_upscaled/Paulo S Assis.jpeg"
  },
  {
    name: " Pasquale D Cavaliere",
    affiliation: "University of Salento, Italy",
    url: "https://www.unisalento.it/scheda-utente/-/people/pasquale.cavaliere",
    imagePath: "/stis2025/assets/speakers_upscaled/Pasquale Daniele CAVALIERE.jpeg"
  },
  {
    name: " Kazuki Morita",
    affiliation: " The University of Tokyo, Japan",
    url: "https://www.material.t.u-tokyo.ac.jp/faculty/morita_e.html",
    imagePath: "/stis2025/assets/speakers_upscaled/Kazuki Morita.png"
  },
  {
    name: "G.A Brooks",
    affiliation: "Swinburne University, Australia",
    url: "https://www.swinburne.edu.au/research/our-research/access-our-research/find-a-researcher-or-supervisor/researcher-profile/?id=gbrooks/",
    imagePath: "/stis2025/assets/speakers_upscaled/Geoffrey Brooks.jpeg"
  },
  {
    name: " Olena Volkova",
    affiliation: "Technical University Frieberg, Germany",
    url: "https://www.researchgate.net/profile/Olena-Volkova-2",
    imagePath: "/stis2025/assets/speakers_upscaled/Olena Volkova.png"
  },
  {
    name: " S.J. KIM",
    affiliation: "Chosun University, Korea",
    url: "https://www.unlv.edu/people/sj-kim",
    imagePath: "/stis2025/assets/speakers_upscaled/Sun-Joong Kim.jpeg"
  },
  {
    name: " M. Hayashi",
    affiliation: "Institute of Science, Tokyo, Japan",
    url: "",
    imagePath: "/stis2025/assets/speakers_upscaled/miyuki hayashi.jpg"
  },
  {
    name: " Ricardo Carli",
    affiliation: "Prosimet, Italy",
    url: "https://www.linkedin.com/in/riccardo-carli-431a1446/?originalSubdomain=it",
    imagePath: "/stis2025/assets/speakers_upscaled/Riccardo Carli.jpeg"
  },
  {
    name: " Jorge Madias",
    affiliation: "Metallion, Argentina",
    url: "https://www.researchgate.net/profile/Jorge-Madias",
    imagePath: "/stis2025/assets/speakers_upscaled/Jorge-Madias.png"
  },

  {
    name: " Charlotte Anderson",
    affiliation: "Lulea University of Technology, Sweden",
    url: "https://www.physicaltherapy.utoronto.ca/charlotte-anderson",
    imagePath: "/stis2025/assets/speakers_upscaled/Charlotte.jpg"
  },

  {
    name: " Brahma Deo",
    affiliation: "IIT Bhubaneswar, India ",
    url: "https://www.iitbbs.ac.in/index.php/bdeo",
    imagePath: "/stis2025/assets/speakers_upscaled/Brahma Deo.jpg"
  },

  {
    name: " Dipak Mazumdar",
    affiliation: "IIT Kanpur, India",
    url: "https://home.iitk.ac.in/~dipak/",
    imagePath: "/stis2025/assets/speakers_upscaled/Dipak Mazumdar.jpg"
  },

  {
    name: " R H Tupkary",
    affiliation: "Former Prof VNIT Nagpur, India",
    url: "",
    imagePath: "/stis2025/assets/speakers_upscaled/R H Tupkary.jpeg"
  },

  {
    name: "Gour Gopal Roy",
    affiliation: "IIT Kharagpur, India",
    url: "http://www.metal.iitkgp.ac.in/People/facultyDetails/6",
    imagePath: "/stis2025/assets/speakers_upscaled/GG Roy.png"
  },

  {
    name: " Keith Vining",
    affiliation: "CSIRO, Australia",
    url: "https://people.csiro.au/V/K/Keith-Vining",
    imagePath: "/stis2025/assets/speakers_upscaled/Keith-Vining.jpeg"
  },

  {
    name: " Amarendra K Singh",
    affiliation: " IIT Kanpur, India",
    url: "https://www.iitk.ac.in/new/amarendra-kumar-singh ",
    imagePath: "/stis2025/assets/speakers_upscaled/amrendra-singh.jpeg"
  },

  {
    name: " LIU Jianhua",
    affiliation: "USTB, China",
    url: "https://ieten.ustb.edu.cn/Discipline/yjgcly/2019-12-07/ed15a296dd6f480d97ec60ea1b7d5af3.htm",
    imagePath: "/stis2025/assets/speakers_upscaled/LIU Jianhua.jpeg"
  },

  {
    name: " Kamalesh Mandal",
    affiliation: "Steel Dynamics, USA",
    url: "https://www.linkedin.com/in/kamalesh-mandal-phd-49140626/",
    imagePath: "/stis2025/assets/speakers_upscaled/Kamalesh Mandal.jpeg"
  },

  {
    name: " Seshadri Seetharaman ",
    affiliation: "Emeritus Professor at the Royal Institute of Technology, KTH, Sweden",
    url: "http://www.femri.org/team-detail-indiv-2.aspx#:~:text=Sheshadri%20Seetharaman,of%20Technology%2C%20KTH%2C%20Sweden",
    imagePath: "/stis2025/assets/speakers_upscaled/Seshadri Seetharaman.jpeg"
  },

  {
    name: " Narasimha Mangadoddy",
    affiliation: "IIT Hyderabad, India",
    url: "https://www.iith.ac.in/che/narasimha/",
    imagePath: "/stis2025/assets/speakers_upscaled/Dr. Narasimha Mangadoddy.jpeg"
  },

  {
    name: "Shatrughan Soren",
    affiliation: "IIT (ISM), Dhanbad, India",
    url: "https://www.iitism.ac.in/faculty-details?faculty=ssoren",
    imagePath: "/stis2025/assets/speakers_upscaled/Dr. Shatrughan Soren.jpeg"
  },

  {
    name: "Nikhil Dhawan",
    affiliation: "IIT Roorkee, India",
    url: "https://iitr.ac.in/Departments/Metallurgical%20and%20Materials%20Engineering%20Department/People/Faculty/100714.html",
    imagePath: "/stis2025/assets/speakers_upscaled/Dr. Nikhil Dhawan .jpeg"
  },

  {
    name: "Sabita Sarkar",
    affiliation: "IIT Madras, India",
    url: "https://mme.iitm.ac.in/faculty-inner.php?id=26&fc=1",
    imagePath: "/stis2025/assets/speakers_upscaled/Dr. Sabita Sarkar.jpeg"
  },

  {
    name: "A.K. Shukla",
    affiliation: "IIT Madras, India",
    url: "https://mme.iitm.ac.in/faculty-inner.php?id=25&fc=1",
    imagePath: "/stis2025/assets/speakers_upscaled/AK Shukla.jpeg"
  },

  {
    name: "Haijuan Wang",
    affiliation: "University of Science and Technology, Beijing, China",
    url: "https://scholar.google.com/citations?user=JB_hNRgAAAAJ&hl=zh-CN",
    imagePath: "/stis2025/assets/speakers_upscaled/Prof. Haijuan Wang.jpeg"
  },

  // added
  {
    name: "Warren Flentje",
    affiliation: "CSIRO, Australia",
    url: "https://people.csiro.au/f/w/warren-flentje",
    imagePath: "/stis2025/assets/speakers_upscaled/Warren.png"
  },

  {
    name: "Viswanathan Nurni",
    affiliation: "Sajjan Jindal Steel Chair Professor, India",
    url: "https://www.mems.iitb.ac.in/~vichu/",
    imagePath: "/stis2025/assets/speakers_upscaled/Viswanathan.jpg"
  },

  {
    name: "Sripriya R",
    affiliation: "Tata Steel, The Netherland",
    url: "https://www.linkedin.com/in/sripriya-r-88486139/?originalSubdomain=nl",
    imagePath: "/stis2025/assets/speakers_upscaled/sripriya.jpg"
  },
  {
    name: "Bharat Bhushan",
    affiliation: "Tata Steel Downstream Products Limited",
    url: "",
    imagePath: "/stis2025/assets/speakers_upscaled/Bharat Bhushan.jpg"
  },

  {
    name: "Youngjo Kang",
    affiliation: "Department of Materials Science Engineering, Dong-A University",
    url: "",
    imagePath: "/stis2025/assets/speakers_upscaled/youngjo kang.jpg"
  },
  // Carsten Schwandt
  {
    name: "Carsten Schwandt",
    affiliation: "Gdańsk University of Technology",
    url: "https://www.linkedin.com/in/carsten-schwandt-1335719/?originalSubdomain=uk",
    imagePath: "/stis2025/assets/speakers_upscaled/Carsten Schwandt.jpg"
  },
];


const HomePage = () => {
  const [timeRemaining, setTimeRemaining] = useState({});
  const [fadeIn, setFadeIn] = useState(false);
  const [userPayments, setUserPayments] = useState([]);
  const [userName, setUserName] = useState(null);
  const [loadingPayments, setLoadingPayments] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const endTime = new Date("2025-12-09T00:00:00").getTime();
    const update = () => setTimeRemaining(calculateTimeRemaining(endTime));

    update();
    const interval = setInterval(update, 1000);
    setFadeIn(true);

    // Show popup after 1 second
    const popupTimer = setTimeout(() => {
      setShowPopup(true);
    }, 1000);

    const fullName = sessionStorage.getItem("fullName");
    const uid = sessionStorage.getItem("uid");

    if (fullName && uid) {
      setUserName(fullName);
      fetchUserPayments(uid);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(popupTimer);
    };
  }, []);

  const fetchUserPayments = async (uid) => {
    try {
      const response = await fetch(`https://api.rescons.in/user-info/${uid}`);
      const data = await response.json();
      if (data && data.payments) {
        setUserPayments(data.payments);
      }
    } catch (error) {
      console.error("Error fetching user payments:", error);
    } finally {
      setLoadingPayments(false);
    }
  };

  return (
    <>
      {/* POPUP MODAL
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button
              className="popup-close"
              onClick={() => setShowPopup(false)}
              aria-label="Close popup"
            >
              ✖
            </button>

            <div className="popup-content">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1055/1055183.png"
                alt="Alert"
                className="popup-icon"
              />
              <h2 className="popup-title">
                Paper Submission Date Extended!
              </h2>
              <p className="popup-message">
                <strong>Last date:</strong> 2nd October 2025 <br />
                <span className="popup-highlight">
                  No further extension will be given.
                </span>
              </p>
              <button
                className="popup-button"
                onClick={() => setShowPopup(false)}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )} */}

      <ImpersonationBanner />
      <Navbar />

      <section className={`hero-section ${fadeIn ? "fade-in" : ""}`}>
        <div className="hero-content">
          <h1 className="hero-title">
            Fifth International Conference on the Science & <br />
            Technology of Ironmaking and Steelmaking
          </h1>
          <h2 className="hero-subtitle">STIS - V 2025</h2>

          <p className="conference-info">
            9th - 12th December 2025 |{" "}
            <a
              className="location"
              href="https://www.google.com/maps/place/IISc+Bengaluru/@13.0170414,77.5633512,17z"
              target="_blank"
              rel="noopener noreferrer"
            >
              Indian Institute of Science, Bengaluru
            </a>
          </p>

          <div className="cta-buttons">
  <a 
    href="/stis2025/register" 
    className="cta-btn cta-register"
  >
    Join the Conference
  </a>

  <a 
    href="/stis2025/assets/2ndAnnouncement.pdf"   // replace with actual PDF path
    target="_blank"
    rel="noopener noreferrer"
    className="cta-btn cta-register"
    style={{
      backgroundColor: '#4a41ceff',  // blue; change to '#28a745' for green
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '8px',
      textDecoration: 'none',
      display: 'inline-block',
      cursor: 'pointer'
    }}
  >
    Final Announcement
  </a>
  <a 
    href="/stis2025/assets/schd.pdf"   // replace with actual PDF path
    target="_blank"
    rel="noopener noreferrer"
    className="cta-btn cta-register"
    style={{
      backgroundColor: '#e4c933ff',  // blue; change to '#28a745' for green
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '8px',
      textDecoration: 'none',
      display: 'inline-block',
      cursor: 'pointer'
    }}
  >
    Tentative Schedule
  </a>
</div>

          
          <section className="speakers-section">
            <div className="speakers-marquee">
              <div className="speakers-track">
                {[...speakers, ...speakers].map((speaker, idx) => (
                  <div className="speaker-card-rect" key={idx + speaker.name}>
                    <div className="speaker-img-wrapper">
                      <img
                        src={speaker.imagePath}
                        alt={speaker.name}
                        className="speaker-img-rect"
                      />
                    </div>
                    <div className="speaker-info-slide">
                      <h3>{speaker.name}</h3>
                      <p>{speaker.affiliation}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>

      <section className="tutorial-video-section">
        <h2 className="tutorial-title">How to Login</h2>
        <div className="video-wrapper">
          <video controls>
            <source src="/stis2025/assets/Login.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      <div className="media-partners" id="sponsors">
        <h2>Sponsors</h2>
        <div className="media-partner-logos">
          <img src="/stis2025/assets/JSw.png" alt="JSW" />
          <img src="https://media.licdn.com/dms/image/v2/D560BAQHPVciDMoD0Bg/company-logo_200_200/company-logo_200_200/0/1739250247270/mspllimited_logo?e=2147483647&v=beta&t=J7E2v6namigKhR9hoVnezoNQgz20l4Tf9ePbMnaNARQ" alt="MSPL" />
          <img src="https://www.knime.com/sites/default/files/public/2024-04/tata-steel-logo.svg" alt="Tata Steel" />
          <img src="/stis2025/assets/sail.png" alt="Sail" />
          <img src="https://dst.gov.in/sites/all/modules/customs/cmf_content/assets/images/dst-logo1.jpg" alt="DST" style={{ width: "200px" }} />
          <img src="/stis2025/assets/sun.png" alt="Sunflag Steel" />
          <img src="/stis2025/assets/processpump.JPG" alt="Process Pump" />
          <img src="/stis2025/assets/rescons_logo .jpg" alt="Rescons" />
        </div>
      </div>

      <div className="media-partners media" id="mediapartners">
        <h2>Media Partners</h2>
        <div className="media-partner-logos">
          <img src="/stis2025/assets/IOM.jpg" alt="IOM" />
          <img src="https://raw.githubusercontent.com/VishwasPrabhakara/STISV/refs/heads/main/public/All-conference-alert.png" alt="All conference Alert" style={{ width: "200px" }} />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HomePage;